import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Instagram } from "lucide-react";
import { shareCard, storyPng } from "../lib/cardImage";
import { storyTemplates } from "../lib/storyTemplates";

export function StoryDesigner({ f, logo, color, qrRef, qrUrl, branches, disabled, ls = 1 }) {
  const templates = useMemo(() => storyTemplates(branches), [branches]);
  const [tid, setTid] = useState("klasik");
  const tpl = templates.find((t) => t.id === tid) || templates[0];
  const [headline, setHeadline] = useState(tpl.headline);
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const pick = (t) => { setTid(t.id); setHeadline(t.headline); };
  const render = () => storyPng({ f, logo, color, qrSvg: qrRef.current?.innerHTML || "", headline, iconSvg: tpl.iconSvg, bullets: tpl.bullets, ls });
  useEffect(() => {
    if (disabled) return undefined;
    let url = "";
    const t = setTimeout(async () => { const b = await render(); url = URL.createObjectURL(b); setPreview(url); }, 350);
    return () => { clearTimeout(t); if (url) URL.revokeObjectURL(url); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tid, headline, color, logo, f.name, f.title, f.phone, disabled, qrUrl, ls]);
  const share = async () => {
    setBusy(true);
    try {
      const r = await shareCard(await render(), `Online teklif: ${qrUrl}`, `instagram-hikaye-${tpl.id}.png`);
      if (r === "downloaded") toast.success("Hikâye görseli indirildi; Instagram'da hikâye olarak paylaşabilirsiniz");
    } catch { toast.error("Görsel oluşturulamadı"); } finally { setBusy(false); }
  };
  return (
    <div className="story-designer" data-testid="story-designer">
      <h4 className="bcard-h">Instagram hikâye şablonu</h4>
      <div className="story-chips">
        {templates.map((t) => (
          <button type="button" key={t.id} className={`chip ${t.id === tid ? "chip-active" : ""}`} onClick={() => pick(t)} data-testid={`story-tpl-${t.id}`}>{t.label}</button>
        ))}
      </div>
      <div className="story-row">
        <div className="story-preview" data-testid="story-preview">{preview ? <img src={preview} alt="Hikâye önizleme" /> : <span className="muted small">Hazırlanıyor…</span>}</div>
        <div className="story-side">
          <label className="field"><span>Başlık</span>
            <textarea rows={3} value={headline} onChange={(e) => setHeadline(e.target.value)} maxLength={70} data-testid="bcard-story-headline" /></label>
          {tpl.bullets.length > 0 && <ul className="story-bullets">{tpl.bullets.map((b) => <li key={b}>{b}</li>)}</ul>}
          <button type="button" className="primary-button bcard-story" onClick={share} disabled={disabled || busy} data-testid="bcard-story"><Instagram size={14} /> {busy ? "Hazırlanıyor…" : "Hikâyeyi paylaş / indir"}</button>
        </div>
      </div>
    </div>
  );
}
